import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Parameter } from 'shapediver-types';

type State = {
  parameters: Parameter.ParameterDefinition[];
};

const modelSlice = createSlice({
  name: 'options',
  initialState: {
    parameters: [],
  } as State,
  reducers: {
    initializeModel(state, action: PayloadAction<State>) {
      Object.assign(state, action.payload);
    },
  },
});

const { initializeModel } = modelSlice.actions;

export { initializeModel };
export default modelSlice.reducer;
